import { render, staticRenderFns } from "./stockup-add.vue?vue&type=template&id=c260528a"
import script from "./stockup-add.vue?vue&type=script&lang=ts"
export * from "./stockup-add.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports